"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popper.default;
  }
});

var _Popper = _interopRequireDefault(require("./Popper"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Popper/index.js
// module id = 477
// module chunks = 0